export default "__VITE_ASSET__$eKnnW3q__"